// removed by extract-text-webpack-plugin
module.exports = {"loader":"ltrbp","spinner":"_2oW6p","rotation":"_2ZqrW"};


/*****************
 ** WEBPACK FOOTER
 ** ./web_modules/layouts/PageLoading/index.css
 ** module id = 511
 ** module chunks = 0
 **/